<template>
  <div class="auth__wrapper">
    <router-view />

    <p class="auth__wrapper-description">
      Вы входите в личный кабинет МТС Спутниковое ТВ
    </p>
    <TheFooterAuthMobile />
  </div>
</template>

<script setup>

import TheFooterAuthMobile from '@/components/TheFooterAuthMobile';
</script>

<style>
.auth__wrapper {
  --white:#fff;
  --black:#000000;
  --radius:8px;
  --border-input-size: 0.125rem;
}

.auth__wrapper {
  min-height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: var(--secondary-grey-ultra-light);
}

.auth__wrapper-description {
  margin: 0;
  font-family: 'MTS Sans', serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--secondary-grey);
}

.auth__form-another-check {
  margin-top: 32px;
}

.auth__form {
  margin-top: 73px;
  padding: 48px;
  height: fit-content;
  border-radius: 8px;
  background-color: var(--white);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 368px;
  box-sizing: border-box;
  margin-bottom: 24px;
}

.auth__form-logo {
  margin-bottom: 0.75rem;
}

.auth__form-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: var(--black);
  margin: 0 0 12px 0;
  font-family: 'MTS Sans', serif;
}

.auth__form-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin: 0 0 12px 0;
  font-family: 'MTS Sans', serif;
}

@media (max-width: 768px) {
  .auth__wrapper-description{
    display: none;
  }

  .auth__form {
    background-color: var(--secondary-grey-ultra-light);
    max-width:100%;
    padding: 0 32px;
  }
}
</style>
